import { createSlice } from '@reduxjs/toolkit';
import type { ProjectSupportState } from './types';

const slice = createSlice({
  name: 'projectSupport',
  initialState: {
    constructionCategories: [],
    constructionTypes: [],
    phaseTypes: [],
    procurementMethods: [],
    deliveryMethods: [],
    budgetRanges: [],
    buildingCategories: [],
    projectTypes: [],
    estimateTypes: [],
    loading: false,
  } as ProjectSupportState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    setData: (state, action) => {
      state.constructionCategories = action.payload.constructionCategories;
      state.constructionTypes = action.payload.constructionTypes;
      state.phaseTypes = action.payload.phaseTypes;
      state.procurementMethods = action.payload.procurementMethods;
      state.deliveryMethods = action.payload.deliveryMethods;
      state.budgetRanges = action.payload.budgetRanges;
      state.buildingCategories = action.payload.buildingCategories;
      state.projectTypes = action.payload.projectTypes;
      state.estimateTypes = action.payload.estimateTypes;
      state.language = action.payload.language;
      state.loading = false;
      state.error = undefined;
    },
  },
});

export const projectSupportActions = slice.actions;
export const projectSupportReducer = slice.reducer;
